import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'
import { cleanId } from '@modules-deprecated/bankReconciliation/utils'

import { BookkeepingItem } from '../types/bookkeepingItem'

export const validateSuggestion = (
  suggestion?: ReconciliationSuggestion,
  bookkeepingItems?: BookkeepingItem[],
): BookkeepingItem | undefined => {
  if (!suggestion || !bookkeepingItems) {
    return undefined
  }

  const reconcilable = suggestion.reconcilables?.[0]

  if (!reconcilable) {
    return undefined
  }

  const [, extractedId] = cleanId(reconcilable.id)
  return bookkeepingItems.find((item) => item.id === extractedId)
}
